// src/components/InfoIcon.jsx
import React from "react";
import PropTypes from "prop-types";
import { AiOutlineInfoCircle } from "react-icons/ai";
import "../styles/InfoIcon.css"; // Ensure this CSS file exists

const InfoIcon = ({ onClick, ariaLabel, title }) => (
  <AiOutlineInfoCircle
    className="info-icon"
    title={title}
    onClick={onClick}
    aria-label={ariaLabel}
    role="button"
    tabIndex={0}
    onKeyPress={(e) => {
      if (e.key === "Enter") onClick();
    }}
  />
);

InfoIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  title: PropTypes.string,
};

InfoIcon.defaultProps = {
  title: "Information",
};

export default InfoIcon;
